import { Punters } from './Punters';

export default Punters;
